/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useRef } from 'react';
import { Typography } from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import { FormTextField, TextFieldPopover } from 'components/TextField';

import { moneyMask } from 'utils/masks';
import useFieldCustomization from 'hooks/useFieldCustomization';
import useTranslate, { Trans } from 'hooks/useTranslate';
import withOptional from './withOptional';

interface PropTypes {
  fieldId?: string;
  fieldName?: string;
  label?: string;
}

const AnnualIncomeField: React.FC<PropTypes> = ({
  fieldId,
  fieldName,
  label,
}) => {
  const annualIncomeRef = useRef<HTMLDivElement | null>(null);
  const { isRequired, isVisible } = useFieldCustomization();
  const t = useTranslate();
  if (!isVisible('annualIncome')) {
    return null;
  }

  return (
    <React.Fragment>
      <Field name={fieldName || 'income'}>
        {(fieldProps: FieldProps) => (
          <FormTextField
            id={fieldId || 'creditAppIncome'}
            inputRef={annualIncomeRef}
            fieldProps={fieldProps}
            required={isRequired('annualIncome')}
            label={
              label ||
              withOptional(
                t('formLabel.annualIncome'),
                isRequired('annualIncome'),
              )
            }
            mask={moneyMask}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
          />
        )}
      </Field>
      <TextFieldPopover id="annualIncome" textFieldRef={annualIncomeRef}>
        <Typography variant="body2" gutterBottom={true}>
          <Trans i18nKey="creditApplication.incomeDisclosure1" />
        </Typography>

        <Typography variant="body2" gutterBottom={false}>
          <Trans i18nKey="creditApplication.incomeDisclosure2" />
        </Typography>
      </TextFieldPopover>
    </React.Fragment>
  );
};

export default AnnualIncomeField;
